<section aria-labelledby="tracker-title">
  <div class="section-heading">
    <div>
      <h2 id="tracker-title">Tracker {{ production ? 'Production' : 'AT' }}</h2>
    </div>
    <label class="stage-toggle">
      <span>AT</span>
      <input type="checkbox" [(ngModel)]="production" (ngModelChange)="stageChanged()" aria-label="Use production tracker">
      <span>Production</span>
    </label>
  </div>

  <!-- <app-api-endpoint [endpoint]="endpoint()" /> -->

  <form class="tracker-query form-surface" #trackerForm="ngForm" (ngSubmit)="submit()">
    <div class="tracker-primary-fields">
      <div class="form-field">
        <label for="tracker-item-id">Item ID</label>
        <input id="tracker-item-id" name="itemId" class="form-control" [(ngModel)]="itemId" (ngModelChange)="itemChanged($event)" required>
        @if (loadingDates()) {
          <small class="field-note">Loading item dates...</small>
        }
      </div>
      <div class="form-field">
        <label for="tracker-start">Logs from</label>
        <input id="tracker-start" name="startTime" type="datetime-local" class="form-control" [(ngModel)]="startTime" [max]="maxTime" required>
      </div>
      <div class="form-field">
        <label for="tracker-end">Logs to</label>
        <input id="tracker-end" name="endTime" type="datetime-local" class="form-control" [(ngModel)]="endTime" [max]="maxTime" required>
      </div>
    </div>

    <div class="filter-heading">
      <span>Request filters</span>
      <div>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setAllFilters(true)">Check all</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setAllFilters(false)">Uncheck all</button>
      </div>
    </div>
    <div class="filter-grid">
      @for (filter of filters(); track filter.label; let index = $index) {
        <label>
          <input type="checkbox" [checked]="filter.checked" (change)="toggleFilter(index, $any($event.target).checked)">
          <span>{{ filter.label }}</span>
        </label>
      }
    </div>
    <div class="form-actions">
      <button type="submit" class="btn btn-primary" [disabled]="trackerForm.invalid">Run query</button>
    </div>
  </form>

  <div class="tracker-status" aria-live="polite">
    <span>Status: <strong>{{ status() }}</strong></span>
    @if (country()) {
      <span>Country: <strong>{{ country() }}</strong></span>
    }
  </div>

  @if (groups().length > 0) {
    <div class="timeline" aria-label="Transaction timeline">
      @for (group of groups(); track $index) {
        <section class="timeline-group">
          <header>
            <span class="date-badge"><strong>{{ group.logs[0].day }}</strong>{{ group.logs[0].month }}</span>
            <h3>{{ group.key }}</h3>
          </header>
          <div class="timeline-logs">
            @for (item of group.logs; track $index) {
              <article [class.alarm]="item['alarm']">
                <div class="timeline-message">
                  <strong>{{ item.displayMessage }}</strong>
                  @if (item.duplicateCount > 1) {
                    <span class="duplicate-count">x{{ item.duplicateCount }}</span>
                  }
                </div>
                @if (item['accesstype']) { <span>Access type: {{ item['accesstype'] }}</span> }
                @if (item['current']) { <span>Status: {{ item['current'] }}</span> }
                @if (item['event']) { <span>Event: {{ item['event'] }}</span> }
                @if (item['deviation']) { <span>Deviation: {{ item['deviation'] }} @if (item['errorcode']) { ({{ item['errorcode'] }}) }</span> }
                @if (item['revoketype']) { <span>Revoke type: {{ item['revoketype'] }}</span> }
                @if (item['parcelaction']) { <span>Parcel action: {{ item['parcelaction'] }}</span> }
                @if (item['reason']) { <span>Reason: {{ item['reason'] }}</span> }
                @if (item['keyrequeststatus']) { <span>Key status: {{ item['keyrequeststatus'] }}</span> }
                @if (item['overallkeyrequest']) { <span>Request status: {{ item['overallkeyrequest'] }}</span> }
                @if (item['clientid']) { <span>Client ID: {{ item['clientid'] }}</span> }
                <footer>
                  <time>{{ item.time }}</time>
                  <code>{{ item.requestid }}</code>
                </footer>
              </article>
            }
          </div>
        </section>
      }
    </div>
  } @else if (status() === 'DONE') {
    <div class="empty-state">No tracker entries matched this query.</div>
  }

  @if (call.error() !== undefined) {
    <app-api-result
      [endpoint]="endpoint()"
      [showEndpoint]="false"
      [request]="call.request()"
      [response]="call.response()"
      [error]="call.error()"
    />
  }
</section>